const getters = {
  token: state => state.user.token,
  dictData: state => state.cache.dictData,
  language: state => state.app.language,
  weChatInfo: state => state.app.weChatInfo,
  userInfo: state => state.user.userInfo,
  signUrl: state => state.app.signUrl,
}
export default getters
